<template>
  <div>
    <back-nav to="PersonalDetailsReview" />
    <v-card class="tw-pb-12 tw-px-4">
      <card-title icon="mdi-autorenew">Switch Cover Type</card-title>
      <div class="tw-px-0 md:tw-px-10 xl:tw-px-16">
        <v-card
            id="comprehensive"
            :class="['tw-w-full mx-auto md:tw-py-6 tw-bg-no-repeat tw-bg-right-bottom tw-bg-center tw-mt-4 md:tw-mt-8', currentPolicy.covertypeId === 1200000 ? '' : 'md:tw-w-7/12']"
            outlined
            style="background-image: url(/images/icons/car-gray.png);"
        >
          <div class="tw-w-full tw-flex-wrap tw-flex">
            <div :class="['tw-w-full tw-px-2 md:tw-px-8 tw-py-4 tw-border-r-0 tw-border-gray-400', currentPolicy.covertypeId === 12000 ? 'md:tw-w-7/12 md:tw-border-r-2' : '']">
              <div class="tw-flex tw-flex-wrap">
                <img src="/images/icons/car.png" class="tw-" alt="car icon">
                <h3 class="c-blue-text title-font tw-text-base md:tw-text-2xl tw-px-3 tw-capitalize">{{  currentPolicy.covertype }} <br> Insurance Cover</h3>
              </div>

              <v-expansion-panels v-model="panel" :multiple="true" :flat="true" class="tw-mt-0 md:tw-mt-0" accordion>
                <v-expansion-panel class="tw-mt-8">
                  <v-expansion-panel-header color="primary1" class="tw-text-white tw-mt-4">Benefits
                    <template v-slot:actions>
                      <v-icon color="#fff">$expand</v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="tw-w-full tw-mt-3 md:tw-mt-5">
                    <benefits v-if="currentPolicy.covertypeId === 101" />
                    <third-party-benefits v-if="currentPolicy.covertypeId === 106" />
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <div class="tw-w-full tw-w-flex tw-justify-end">
                <v-card-actions class="tw-w-1/2 tw-mt-4">
                  <v-btn block large
                         id="renewComp"
                         color="secondary"
                         class="my-3 "
                         @click="proceed"
                  >
                    Switch to {{ currentPolicy.covertype }}
                  </v-btn>
                </v-card-actions>
              </div>
            </div>
            <div v-if="currentPolicy.covertypeId === 120000" class="tw-w-full md:tw-w-5/12 tw-px-2 md:tw-px-8 tw-py-4 tw-flex tw-flex-wrap tw-content-between ">
              <div class="tw-w-full tw-flex tw-flex-wrap">
                <h3 class="c-blue-text title-font tw-text-xl md:tw-text-2xl tw-px-3">Premium Calculator</h3>
                <div class="tw-w-full tw-mt-5 md:tw-mt-12">
                  <div class="tw-w-full tw-flex">
                    <p class="c-blue-text tw-font-bold tw-w-7/12 md:tw-w-8/12">Basic premium</p>
                    <p v-if="currentPolicy.covertypeId === 101" class="c-gray-text tw-text-left">Kshs. {{ (premiumAmount - (levy(premiumAmount) + pchf(premiumAmount)+ 40)) | formatNum }}</p>
                    <p v-else class="c-gray-text tw-text-left">Kshs. {{ (premiumAmount - (levy(premiumAmount) + pchf(premiumAmount))) | formatNum }}</p>
                  </div>
                  <div class="tw-w-full tw-flex">
                    <p class="c-blue-text tw-font-bold tw-w-7/12 md:tw-w-8/12">Training levy</p>
                    <p class="c-gray-text"> Ksh. {{ levy(premiumAmount) }}</p>
                  </div>
                  <div class="tw-w-full tw-flex">
                    <p class="c-blue-text tw-font-bold tw-w-7/12 md:tw-w-8/12">PCHF</p>
                    <p class="c-gray-text"> Ksh. {{ pchf(premiumAmount) }}</p>
                  </div>
                  <div v-if="currentPolicy.covertypeId === 101" class="tw-w-full tw-flex">
                    <p class="c-blue-text tw-font-bold tw-w-7/12 md:tw-w-8/12">Stamp duty</p>
                    <p class="c-gray-text">Ksh. 40</p>
                  </div>
                </div>
              </div>
              <div class="tw-w-full tw-mt-5 md:tw-mt-4">
                <h4 class="c-blue-text tw-font-bold tw-text-sm">Renewal Premium</h4>
                <h2 class="c-light-blue-text title-font tw-text-3xl md:tw-text-5xl">Ksh. {{ premiumAmount | formatNum }}</h2>
                <v-card-actions class="tw-w-1/2 tw-mt-2">
                  <v-btn block large
                         id="renewComp"
                         color="secondary"
                         class="my-3 "
                         @click="proceed"
                  >
                    Switch to {{ currentPolicy.covertype }}
                  </v-btn>
                </v-card-actions>
              </div>
            </div>
          </div>
        </v-card>

      </div>
    </v-card>
  </div>
</template>

<script>
import BackNav from '@/components/buy/BackNav';
import CardTitle from '@/components/shared/CardTitle';
import Benefits from '@/components/shared/Benefits';
import helpers from '@/utils/helpers';
import ThirdPartyBenefits from '@/components/shared/ThirdPartyBenefits';
import { FB_RENEW_CHANGE_PROCEED } from '@/utils/const';

export default {
  name: 'SwitchCover',
  components: {
    ThirdPartyBenefits, Benefits, CardTitle, BackNav,
  },
  props: ['renewal'],
  data() {
    return {
      panel: [0],
      panel2: 0,
    };
  },
  computed: {
    currentPolicy() {
      return this.renewal.quote.covertypes.find((id) => id.selected === 'Y');
    },
    premiumAmount() {
      return this.currentPolicy.riskPremDto.totalPremium || 0;
    },
  },
  methods: {
    proceed() {
      const data = {
        quoteDetails: this.renewal.quote,
        batchId: this.renewal.batchId,
      };
      this.$analytics.logEvent(FB_RENEW_CHANGE_PROCEED, { product: 'Renewal Journey Proceed with Change' });
      this.$emit('to-vehicle-details-review', { data, switchedCover: true });
    },
    levy(amount) {
      return Math.round((0.2 / 100) * amount);
    },
    pchf(amount) {
      return Math.round((0.25 / 100) * amount);
    },
  },
  filters: {
    formatNum(num) {
      return helpers.numberToString(num);
    },
  },
};
</script>
